module.exports = __webpack_public_path__ + "img/top-standard-color-schemes-for-website-design.06fce2fc.jpg";